// extracted by mini-css-extract-plugin
module.exports = {"cntr":"web_cntr__1P_AM","webView":"web_webView__2gRgR"};